import React from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';

class AlertTemplate extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    classNames: PropTypes.string.isRequired,
    styles: PropTypes.instanceOf(Object).isRequired,
    message: PropTypes.oneOfType([
      PropTypes.instanceOf(Object),
      PropTypes.string,
    ]).isRequired,
  }

  static defaultProps = {
    id: '',
  }

  state = {
    visible: true,
  }

  componentDidMount() {
    const elem = document.getElementById('alert-override');
    if (elem) {
      this.setState({ visible: false });
      const { message } = this.props;
      render(
        <div>
          { message }
        </div>,
        elem,
      );
    }
  }

  render() {
    const {
      classNames, id, styles, message,
    } = this.props;
    const { visible } = this.state;
    const newStyles = !visible
      ? {
        opacity: 0, height: 0, width: 0, overflow: 'hidden',
      }
      : styles;
    return (
      <div className={classNames} id={id} style={newStyles}>
        <div className="s-alert-box-inner">
          {message}
        </div>
      </div>
    );
  }
}

export default AlertTemplate;
